import type { TitleProps } from '@refinedev/core'
import React from 'react'
import styled from 'styled-components'

const TitleContainer = styled.div<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: bold;
  color: #1890ff;
  padding: 16px;
`

const TitleIcon = styled.span`
  font-size: 20px;
`

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
  return (
    <TitleContainer $collapsed={collapsed}>
      <TitleIcon>🏛️</TitleIcon>
      {!collapsed && <span>Archon</span>}
    </TitleContainer>
  )
}
